import {
	type DcrAddressInput,
	ReferenceType
} from '@/core/graphql/generated/types';

import { labelKey as t } from '../labelKey';
import type { CollectionDef, HistoricFieldDef, ItemFieldDef } from '../types';

export const ADDRESS_FIELDS = {
	streetAddress1Cda_V: {
		label: t('Street Address 1'),
		kind: 'text',
		visibility: 'always',
		required: true
	},
	streetAddress2Cda_V: {
		label: t('Street Address 2'),
		kind: 'text',
		visibility: 'always'
	},
	cityCda_V: {
		label: t('City'),
		kind: 'text',
		visibility: 'always',
		required: true
	},
	stateCda_VId: {
		label: t('State'),
		kind: 'picklist',
		picklist: ReferenceType.State,
		visibility: 'always'
	},
	postalCodeCda_V: {
		label: t('Postal Code'),
		kind: 'text',
		visibility: 'always'
	},
	postalCodeFullUs_V: {
		label: t('Full Postal Code US'),
		kind: 'text',
		visibility: 'always',
		countries: ['us']
	},
	countryCda_VId: {
		label: t('Country'),
		kind: 'picklist',
		picklist: 'country',
		visibility: 'always',
		readOnly: true,
		defaultValue: { type: 'entityCountry' }
	},
	subStateAdminUnit_V: {
		label: t('Region/County'),
		kind: 'text',
		visibility: 'always'
	},
	phoneCda_V: {
		label: t('Phone'),
		kind: 'phone',
		visibility: 'always',
		isoKey: 'phoneCountryIso'
	},
	faxCda_V: {
		label: t('Fax'),
		kind: 'phone',
		visibility: 'always',
		isoKey: 'faxCountryIso'
	},
	statusCda_VId: {
		label: t('Status'),
		kind: 'picklist',
		picklist: ReferenceType.Status,
		visibility: 'off',
		defaultValue: { type: 'activeOption' }
	},
	primaryCda_V: {
		label: t('Is Primary'),
		kind: 'boolean',
		visibility: 'off'
	},
	cbsa_VId: {
		label: t('Metropolitan (CBSA)'),
		kind: 'picklist',
		picklist: ReferenceType.Cbsa,
		visibility: 'off'
	},
	subAdministrativeArea_V: {
		label: t('Region/County'),
		kind: 'text',
		visibility: 'off'
	},
	phone1_V: {
		label: t('Phone 1'),
		kind: 'phone',
		visibility: 'off'
	},
	fax1_V: {
		label: t('Fax'),
		kind: 'phone',
		visibility: 'off'
	}
} as const satisfies Partial<Record<keyof DcrAddressInput, ItemFieldDef>>;

export const ADDRESS_INLINE_TEXT_FIELDS = [
	'streetAddress1Cda_V',
	'streetAddress2Cda_V',
	'cityCda_V',
	'subStateAdminUnit_V',
	'postalCodeCda_V',
	'postalCodeFullUs_V'
] as const satisfies readonly (keyof typeof ADDRESS_FIELDS)[];

export type AddressInlineTextField =
	(typeof ADDRESS_INLINE_TEXT_FIELDS)[number];

export const ADDRESS_HISTORIC_FIELDS: readonly HistoricFieldDef[] = [
	{ names: ['addresses_V'], label: t('Address') },
	{ names: ['coordinates_V'], label: t('Coordinates') },
	{
		names: ['phone2_V'],
		label: t('Phone 2'),
		anchor: 'phone1_V',
		kind: 'phone'
	}
];

export const ADDRESS_COLLECTION: CollectionDef = {
	id: 'address',
	itemLabel: t('Address'),
	addLabel: t('Add Address'),
	fields: ADDRESS_FIELDS
};
